export default {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }